module.exports = __webpack_public_path__ + "assets/img/04.5cea7220.png";